import { MessagesPage } from "./messages";

export const Messages = MessagesPage;
